import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0b6ff70b&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b6ff70b')) {
      api.createRecord('0b6ff70b', component.options)
    } else {
      api.reload('0b6ff70b', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0b6ff70b&", function () {
      api.rerender('0b6ff70b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/estimates/Index.vue"
export default component.exports